import React, {useEffect, useState} from "react";
import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import InputTextarea from "../../../../components/input/input-textarea.jsx";
import TaskService from "../../../../services/dispatch/task-service.js";
import projectUtils from "../../../../utils/project-utils.js";

const getErrorMessage = (error, fallback) => {
    const message = error.response?.data?.errorMessages ?? error.response?.data?.message;
    if (Array.isArray(message)) return message.join("<br />");
    return message || fallback;
};

const CloseTaskModal = ({payload, onClose, onSuccess}) => {
    const [cancelObservation, setCancelObservation] = useState("");
    const [validationMessage, setValidationMessage] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const open = Boolean(payload);
    const task = payload?.task ?? payload?.item ?? payload;

    useEffect(() => {
        if (!open) return;
        setCancelObservation("");
        setValidationMessage("");
        setIsSubmitting(false);
    }, [open]);

    const handleSubmit = async () => {
        const observation = cancelObservation.trim();

        if (!observation) {
            setValidationMessage("Informe o motivo do encerramento.");
            return;
        }

        if (!task?.id) {
            projectUtils.swalErrorMessage("Erro", "Não foi possível identificar a tarefa.", "Ok");
            return;
        }

        setIsSubmitting(true);

        try {
            await TaskService.closeTask(task.id, observation);
            onSuccess();
            projectUtils.swalSuccessMessage("success", "Sucesso", "Tarefa encerrada com sucesso.", "Ok");
        } catch (error) {
            console.error("Erro ao encerrar tarefa pelo dashboard:", error);
            projectUtils.swalErrorMessage("", getErrorMessage(error, "Não foi possível encerrar a tarefa."), "Ok");
            setIsSubmitting(false);
        }
    };

    return (
        <Modal open={open} setOpen={onClose} title="Encerrar tarefa" className="w-full max-w-2xl" isCloseClick={false}>
            <Modal.Body className="max-h-[calc(100vh-180px)] flex flex-col gap-4 overflow-auto">
                <InputTextarea
                    id="dashboard-task-close-observation"
                    label="Motivo do encerramento *"
                    className=""
                    textAreaClass="h-[120px]"
                    value={cancelObservation}
                    onChange={({target}) => {
                        setCancelObservation(target.value);
                        if (validationMessage) setValidationMessage("");
                    }}
                    disabled={isSubmitting}
                />

                {validationMessage ? (
                    <div className="rounded border border-red-200 bg-red-50 p-2 text-center text-sm text-red-600">
                        {validationMessage}
                    </div>
                ) : null}
            </Modal.Body>
            <Modal.Footer>
                <Button type="button" target="primary" onClick={handleSubmit} loading={isSubmitting} actionFeedbackType='save'>

                    Salvar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CloseTaskModal;